import { render, staticRenderFns } from "./PatientName.vue?vue&type=template&id=da4d4c94&scoped=true"
import script from "./PatientName.vue?vue&type=script&lang=js"
export * from "./PatientName.vue?vue&type=script&lang=js"
import style0 from "./PatientName.vue?vue&type=style&index=0&id=da4d4c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4d4c94",
  null
  
)

export default component.exports